// extracted by mini-css-extract-plugin
export var addViewLink = "_a-1";
export var availabilityIcon = "_a-16";
export var availabilitySelectionIcon = "_a-15";
export var backButton = "_a-2";
export var backIcon = "_a-z";
export var conversationCount = "_a-3";
export var dragHandle = "_a-5";
export var dropdown = "_a-e";
export var dropdownIcon = "_a-7";
export var dropdownOption = "_a-6";
export var dropdownTriangle = "_a-d";
export var expand = "_a-f";
export var folder = "_a-i";
export var folderItem = "_a-c";
export var icon = "_a-8";
export var iconRow = "_a-9";
export var image = "_a-a";
export var logo = "_a-b";
export var navContainer = "_a-h";
export var navigationFooter = "_a-g";
export var pageShell = "_a-0";
export var placeholderAvailable = "_a-11";
export var placeholderBox = "_a-14";
export var placeholderBusy = "_a-13";
export var placeholderUnavailable = "_a-12";
export var profile = "_a-k";
export var profileContainer = "_a-m";
export var profileDropdown = "_a-n";
export var profileImage = "_a-l";
export var profileMain = "_a-o";
export var profileSubtitle = "_a-q";
export var profileTitle = "_a-p";
export var reorderIcon = "_a-r";
export var sentLine = "_a-u";
export var settingsHeader = "_a-s";
export var sidenavTextColor = "_a-y";
export var spamLine = "_a-t";
export var subitemWithTag = "_a-4";
export var supportItems = "_a-j";
export var teamText = "_a-10";
export var viewLine = "_a-x";
export var viewLineButton = "_a-w";
export var viewLineButtons = "_a-v";